<template>
	<div class="fileinput w-100">
		<div  class="smth">
			<form :id="formId" :name="formId" enctype="multipart/form-data">
				<label class="" v-if="typeof additionalInfo !='undefined' && additionalInfo !=''"> <i class="tim-icons text-danger icon-alert-circle-exc mr-2" style="font-size: 16px;"></i>{{ additionalInfo }}</label>
				<div :class="btnClass.btn" class="btn-file m-0 mr-2 smth-span" v-if="!fileExists || multiple">
					<i :class="btnClass.icon"></i>
					<input
						:accept="acceptMime"
						@change="handlePreview"
						type="file"
						name="in_files"
						ref="in_files"
						class="valid smth-input"
						:multiple="multiple"
						aria-invalid="false"
					/>
				</div>

				<div v-if="fileExists && bShowTrash" :class="[{ 'd-none': multiple == false }, { 'd-inline-block': multiple == true }]" class="" >
					<button class="btn btn-icon btn-simple btn-danger m-0"  v-on:click.prevent.stop="removeFile">
						<i class="tim-icons icon-trash-simple"></i>
					</button>
					<div class="filesCount">{{ photoCount }}</div>
				</div>

				<div class="files-container" v-if="fileExists && bShowTrash && bShowDraggable">
					<p class="py-2" v-if="multiple == true"><i class="tim-icons text-primary icon-alert-circle-exc mr-1"></i> Для изменения порядка фотографии перетащите её на нужную позицию.</p>
					<p class="py-2"><i class="text-primary tim-icons icon-check-2 mr-1"></i> Для Выбора главного фото, отметьте его галочкой в синем поле справа.</p>
					<div class="" :class="[{ 'fastScrollContainer': multiple == true}]">
					<div :class="[{ 'filesContainerSingle': multiple == false }, { 'filesContainer': multiple == true }]">
						<div class="fastScrollSpot" v-if="(multiple == true) || (multiple == false && value < 1)"><span class="text-success">Точка быстрого скролла</span></div>
							<draggable
								class="list-group"
								tag="ul"
								:list="value"
								:disabled="enabled"
								handle=".handle"
								ghostClass="ghost"
								v-bind="dragOptions"
								@start="drag = true"
								@end="drag = false"
								
							>
								<li class="fileItem mb-2 list-group-item handle-old" v-for="(imgSrc,idx) in masPhotos" :key="idx" >
									<div class="mb-2 d-flex" >
										<div class="px-0 handle">
											<div class="fileItemContainer">
												<a :href="imgDocSrc(idx)" target="_blank" class="d-block">
													<div class="itemPhoto mr-2" @click="onImgClick(imgSrc.fullpath)">
														<img :src="imgSrc.fullpath" :id="idx" alt="preview" :style="{transform: `rotate(${(imgSrc.degree?imgSrc.degree:0)}deg)`}" style="transition:0.3s;">
														<span class="itemPhotoPos">{{idx+1}}</span>
													</div>
												</a>

												<el-popover
													v-if="uploadApi.apiParam.flt.type == 'mo_photos'"
													placement="right"
													:title="objImgOrigFn[imgSrc.fullpath]"
													width="350"
													height="350"
													trigger="hover"
													>
													<template v-slot:reference>
														<i class="tim-icons icon-zoom-split text-primary zoomhover mr-2" style="font-size: 26px;"></i>
													</template>
													<template v-slot:default>
														<div class="" style="width:325px; height: 325px;">
															<img :src="imgSrc.fullpath" :id="idx" alt="preview" :style="{transform: `rotate(${(imgSrc.degree?imgSrc.degree:0)}deg)`}" style="transition:0.3s;width:100%; height: 100%; object-fit: cover;">
														</div>
													</template>
													
												</el-popover>
											</div>
										</div>
										<div class="handle" style="width: 100%;">
											<p class="itemTitle" v-if="isImg(imgDocSrc(idx))">{{getTitle(objImgOrigFn[imgSrc.fullpath])}}</p>
											<p class="itemTitle" v-else>{{src_filenames[idx]}}</p>
										</div>
										
										<div class="px-0">
											<div class="d-flex justify-content-end">	
												<div  class="btn btn-icon btn-simple btn-success my-0 mr-1" v-if="bshowClipboard && imgSrc.fullpath!=''">
													<ReCopyClipboard :value="imgSrc.fullpath" imgClipboard />		
												</div>	
												<div v-if="imgSrc.isMain">
													<button class="btn btn-icon btn-simple btn-primary my-0 mr-1 pt-1" v-on:click.prevent.stop="setMain(idx)" style="z-index:100 !important">
														<i class="tim-icons icon-check-2"></i>
													</button>
												</div>
												<div v-else>
													<button class="btn btn-icon btn-simple btn-primary my-0 mr-1" v-on:click.prevent.stop="setMain(idx)" style="z-index:100 !important">
														<i class="tim-icons"></i>
													</button>
												</div>
												<button class="btn btn-icon btn-simple btn-success my-0 mr-1" :disabled="rotateProgress[idx]" v-on:click.prevent.stop="rotateCurrentFile(idx)" style="z-index:100 !important">
													<i class="tim-icons icon-refresh-01"></i>
												</button>
												<button class="btn btn-icon btn-simple btn-danger m-0" v-on:click.prevent.stop="removeCurrentFile(idx)" style="z-index:100 !important">
													<i class="tim-icons icon-simple-remove"></i>
												</button>
											</div>
										</div>
									</div>
								</li>
							</draggable>
						</div>
					</div>
				</div>
			</form>
		</div>
	</div>
</template>

<script>
/*
я тут до конца осознал про v-model и props value внутри компонента:
радовался тому что в value можно писать и всё работает - нихрена. 
1) Если value сложный тип (например массив или объект) - тогда можно элементы массива/объекта и ничего за это не будет, т.к. ЖС говно
2) Если тип простой string или number - то хер чё поменяешь в value, только this.$emit('input', 'ЗНАЧЕНИЕ');
3) Если напрямую переписывать сложные тип, например value = {key:'value'} - то хер, будет ошибка
а ещё во всех слуаях он выдаст ошибку, но значение в value запишет
*/
/* Сломалась реактивность на объекте или массиве: 
	Этот чудесный кослыль родился потому что VUE не может нормально следить за массивами и теряется реактивность
	https://v2.vuejs.org/v2/guide/reactivity.html#Change-Detection-Caveats

Для объекта:
	this.$set(this.objChosenTP,this.ApiData[i].siteId, {'choise':'','cost':0, 'phone':{"contact_id":"","contact_type":"1","contact_value":"","contact_view":"","contact_group":"phone"}});
Для Массива:
	Vue.set(this.masCheckListParams,obj_index, [{val_id:obj_index, elements: masElements}]);
*/

	import { Input, Popover } from "element-ui";
	import draggable from 'vuedraggable';
	import ReCopyClipboard from 'src/our_components/ReCopyClipboard.vue';

	export default {
		name: 'ReImagesUpload',
		components: {
			[Input.name]: Input,
			[Popover.name]: Popover,
			draggable,
			ReCopyClipboard,
		},
		props: {
			findId: { //это свойсво удалять не надо, оно хорошее и моет быть использовано в опуиях для формпринтера или фильтрпринтера
				type: String,
				default: '',
			},
			formId: {
				type: String,
				default: "imgUploadForm"
			},
			multiple: {
				type: Boolean,
				default: false
			},
			type: {
				type: String,
				default: "",
				description: 'Image upload type (""|avatar|file|video)'
			},
			selectText: {
				type: String,
				default: "Выбрать"
			},
			changeText: {
				type: String,
				default: "Изменить"
			},
			removeText: {
				type: String,
				default: "Удалить"
			},
			btnClass: {
				type: Object,
				default: function() {
					return {
						btn: "btn btn-icon btn-simple btn-success",
						icon: "tim-icons icon-attach-87"
					};
				}
			},
			bShowTrash: {
				type: Boolean,
				default: true
			},
			acceptMime: {
				type: String,
				default: "*/*"
			},
			bShowDraggable: {
				type: Boolean,
				default: true
			},
			bshowClipboard: {
				type: Boolean,
				default: false
			},
			uploadApi: {
				type: Object,
				default: function() {
					return {};
				}
			},
			delApi: {
				type: Object,
				default: function() {
					return {};
				}
			},
			help: {
				type: String,
				default: "",
			},
			additionalInfo: {
				type: String,
				default: "",
			},
			src_filenames: {
				type: Array,
				default: function() {
					return [];
				},
				description: "Initial src_filenames image to display"
			},
			value: {
				// модель одной строки {'degree':0,'isMain':false,'fullpath':objApi.data.fullpath}
				type: Array,
				default: function() {
					return [];
				},
				description: "Initial image to display"
			},
		},
		data () {
			let avatarPlaceholder = "/img/placeholder.jpg";
			let imgPlaceholder = "/img/uploadicon.svg";
			return {
				ver: 1,
				placeholder: this.type === "avatar" ? avatarPlaceholder : imgPlaceholder,
				imagePreview: null,
				masImgExtansions:['bmp','tiff','jpeg','jpg','gif','png', 'pdf', 'JPG'],
				objImgDeg: {},
				objImgOrigFn: {},
				bShowSorting: false,
				rotateProgress:{},
			}
		},
		watch: {
			value(val){
				if(this.value instanceof Array && this.type === "file"){
					if(this.value.length > 0 ) this.imagePreview = this.value.length;
				} else {
					if(this.value.length > 0 ) this.imagePreview = this.value[this.value.length - 1];
				}
				
			}
		},
		computed: {
			fileExists() {
				return (
					this.value !== null &&
					this.value != "" &&
					this.value != "/img/placeholder.jpg" &&
					this.value != "/img/uploadicon.svg"
				);
			},
			photoCount(){
				return this.value.length
			},
			/*
			image() {
				return this.imagePreview || this.value || this.src || this.placeholder;
			},
			*/
			masPhotos(){
				//console.log('masPhotos', this.objImgDeg);
				let masRet = [];
				//this.objImgDeg = {};
				this.objImgOrigFn = {};

				for (let i = 0; i < this.value.length; i++) {
					if(this.isImg(this.value[i].fullpath)){
						// console.log('this.value[i]',this.value[i].substring(this.value[i].lastIndexOf('/') + 1));
						masRet.push(this.value[i]);
						if(!this.objImgDeg.hasOwnProperty(this.$GVO.unlinkObject(this.value[i].fullpath))){
							this.$set(this.objImgDeg, this.$GVO.unlinkObject(this.value[i].fullpath), 0);
							this.value[i]['degree'] = 0;
						}
						let strFN = this.value[i].fullpath.substring(this.value[i].fullpath.lastIndexOf('/') + 1);
						// console.log('strFN',strFN);
						if(typeof this.src_filenames[i] !='undefined')strFN = this.src_filenames[i];
						//console.log('strFN2',strFN);
						this.$set(this.objImgOrigFn, this.$GVO.unlinkObject(this.value[i].fullpath), strFN);
					}else{
						masRet.push({'isMain':false,'fullpath':'/img/uploadicon.svg'});
					}
				}
				return masRet
			},
			dragOptions() {
				return {
					animation: 200,
					group: "description",
					disabled: false,
					ghostClass: "ghost"
				};
			},
			enabled(){
				if(this.multiple == true ){
					return false;
				} else {return true;}
			}
		},
		methods: {
			getTitle(name){
				return String(name).split('?')[0];
			},
			onImgClick(strImgPath){
				// console.log(strImgPath);
			},
			isImg(strFileName){
				//console.log('isImg',strFileName)
				const masFile = strFileName.split('.');
				if(masFile.length > 0){
					const ext = masFile[masFile.length-1].split('?')[0];
					if(this.masImgExtansions.indexOf(ext.toLowerCase()) != -1) return true;
				}
				return false;
			},
			imgDocSrc(idx){
				//console.log('imgDocSrc',idx,this.value[idx]);
				return this.value[idx].fullpath;
			},
			setMain(idx){
				//console.log('setMain',idx,this.value[idx]);
				for (let i = 0; i < this.value.length; i++) {
					this.value[i].isMain = false;
					if(i == idx) this.value[i].isMain = true;
				}
				return true;
			},
			handlePreview(event) {
				let files = event.target.files;
				if (this.type != "file") {
					this.imagePreview = URL.createObjectURL(files[0]);
				} else {
					if (files.length > 0) {
						this.imagePreview = files.length;
					}
				}
				this.$emit("change", {
					files: files,
					formId: this.formId,
					selfObj: this
				});
			},
			removeFile() {
				if (!this.$GVO.isEmpty(this.delApi)) {
					this.$GVO
						.ApiCall(this.delApi.apiMethod, this.delApi.apiParam)
						.then(objApi => {
							if (objApi.success === true) {
								this.imagePreview = null;
								this.$emit("change", this.findId);
							}
						})
						.catch(errorObjApi => {
							// console.log(errorObjApi);
							this.bIsLoading = false;
						});
				} else {
					this.$emit("clear", this.findId);
				}
			},
			removeCurrentFile(idx){
				const remImg = this.value.splice(idx, 1);
				if(this.$refs.in_files)
					this.$refs.in_files.value = null;
				if(this.value.length==0){
					this.imagePreview = null;
					this.$emit("change", this.findId);
				}
			},
			async rotateCurrentFile(idx){
				let strImgPath = this.value[idx].fullpath;
				this.objImgDeg[strImgPath] += 90;
				this.value[idx].degree += 90;
				// this.rotateProgress[idx] = true;
				this.$set(this.rotateProgress, idx, true);
				try{
					const objApi = await this.$GVO.Api.FileUpload.RotateImage({flt:{strImgPath}})
					if(objApi.success === true){
						// this.objImgDeg[idx] += 90;
					}
				}catch(errorObjApi){
					console.error(errorObjApi);
				}finally{
					// console.log('idx type:', typeof idx);
					this.$set(this.rotateProgress, idx, false);
					// this.$forceUpdate(); 
				}
			},
			ShowSort(){
				this.bShowSorting = !this.bShowSorting;
			},
		},
	}
</script>
<style>
.fileinput {
	vertical-align: top;
}
.filesCount {
	position: absolute;
	color: white;
	margin-top: -50px;
	margin-left: 35px;
	background-color: red;
	width: 20px;
	height: 20px;
	border-radius: 50%;
	text-align: center;
}

.fileinput .thumbnail > img {
	width: 100px;
	height: 100px;
	object-fit: contain;
}

.fileinput .el-carousel{
	width: 250px;
	margin-top: 10px;
}
.fileinput .el-carousel .imgPreview{
	display: flex;
	justify-content: space-around;
}
.fileinput .el-carousel .imgPreview > img {
	height: 200px;
	object-fit: cover;
}

.btn-removeitem{
	position: absolute !important;
    right: 0px;
}
.btn-rotateitem{
	position: absolute !important;
    right: 40px;
}
.btn-down{
	position: absolute !important;
    right: 80px;
}
.btn-top{
	position: absolute !important;
    right: 120px;
}

.filesContainer {
	padding: 0px 10px 0px 0px;
	height: 350px;
	width: 100%;	
	overflow-y: scroll;	
	
}

.filesContainerSingle {
	width: 100%;	
}
.fileItem {
	padding: 10px;
	border: 1px solid #9e77f3;
	border-radius: 0.2857rem;
	display: flex;
	flex-direction: column;
	flex-wrap: nowrap;
	background-color: inherit;
}
.fileItemContainer {
	display: flex;
}
.itemPhoto {
	display: flex;
    width: 60px;
    height: 60px;
	position: relative;
}
.itemPhoto img{
    width: 100%;
    height: 100%;
    margin: 0 auto;
    object-fit: cover;
}
.itemPhotoPos {
	position: absolute;
	bottom: -4px;
	right: -4px;
	background: #01B0E0;
	border-radius: 50%;
	height: 20px;
    width: 20px;
    color: #fff;
    font-weight: 600;
    display: flex;
    align-items: center;
    justify-content: center;
}
.itemTitle {
	width: 100%;
    word-break: break-word;
}

.list-group-item + .list-group-item {
    border-top-width: thin!important;
}

.ghost {
	opacity: 0.5;
	background: #c8ebfb;
}

.btn-handle{
	border-radius: 0.4285rem;
	display: flex;
    align-items: center;
	cursor: pointer;
}
.fastScrollContainer {position: relative;}
.fastScrollSpot {
	width: 250px; height: 20px; 
	display: none; 
	justify-content: center; 
	position: absolute; 
	top:0; 
	left: calc(50% - 125px); 
	border-radius: 0 0 0.4285rem 0.4285rem;
	border-left: 1px solid #00BF9A; 
	border-right: 1px solid #00BF9A; 
	border-bottom: 1px solid #00BF9A; 
	z-index: 1000;
}
.btnovertext {white-space: pre-wrap!important; word-break: break-word!important;}

@media (max-width: 370px){
	.fileinput .el-carousel {
		width: 200px;
	}
}
@media (max-width: 786px){
	.filesContainer {
		padding: 0px 30px 0px 0px;
	}
}
@media (max-width: 460px){
	.itemTitle {
		display: none;
	}
	
}
</style>
